import * as React from 'react';
import clsx, { ClassValue } from 'clsx';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { Typography, TypographyType } from '../typography';

interface Props {
	align?: 'center' | 'end' | 'start' | undefined;
	textType?: TypographyType;
	trigger: React.ReactNode;
	label: string | React.ReactNode;
	customLabel?: React.ReactNode;
	className?: ClassValue;
	showArrow?: boolean;
	alignOffset?: number;
	classNameLabel?: ClassValue;
	classNameArrow?: ClassValue;
	classNameTrigger?: ClassValue;
	autoWidth?: boolean;
	side?: 'top' | 'right' | 'bottom' | 'left' | undefined;
}

export const TooltipComponent: React.FC<Props> = ({
	trigger,
	label,
	customLabel,
	className,
	align = 'start',
	alignOffset = -20,
	showArrow = true,
	textType = 'regular-12',
	classNameLabel,
	classNameTrigger,
	classNameArrow,
	side,
}) => {
	const [open, setOpen] = React.useState<boolean>(false);

	const handleOpen = (): void => {
		if (!label && !customLabel) return;
		setOpen(true);
	};

	const handleClose = (): void => {
		setOpen(false);
	};
	return (
		<TooltipProvider delayDuration={0}>
			<Tooltip open={open}>
				<TooltipTrigger
					asChild
					onMouseEnter={handleOpen}
					onMouseLeave={handleClose}
					className={clsx('z-10', classNameTrigger)}
				>
					{trigger}
				</TooltipTrigger>
				<RadixTooltip.Portal>
					<TooltipContent
						align={align}
						side={side}
						alignOffset={alignOffset}
						className={clsx(
							'rounded-lg flex items-center p-2 gap-1 border-none bg-[#F6F8E3] w-[175px]',
							className
						)}
					>
						{customLabel || (
							<Typography
								type={textType}
								className={clsx(
									'text-center',
									{
										'whitespace-pre-line':
											typeof label === 'string' && label.includes('\n'),
									},
									classNameLabel
								)}
							>
								{label}
							</Typography>
						)}
						<RadixTooltip.Arrow
							className={clsx(
								'fill-[#F6F8E3]',
								{
									visible: showArrow,
									'!hidden': !showArrow,
								},
								classNameArrow
							)}
						/>
					</TooltipContent>
				</RadixTooltip.Portal>
			</Tooltip>
		</TooltipProvider>
	);
};
